<template>
  <div v-if="brandConfig.featured && !isLoading" class="flex flex-col lg:gap-1 text-foreground z-10">
    <div
      class="bg-background justify-between lg:gap-6 space-y-4 lg:space-y-0 flex flex-col lg:flex-row py-4 pt-0 lg:pt-4 lg:p-0">
      <div class="w-full lg:w-1/2 flex-col gap-6">
        <Card class="mb-4" :to="brandConfig.featured.block1.to">
          <CoverPhoto
            :use-full-path="isStrapiConf"
            :src="brandConfig.featured.block1.photo"
            :alt="brandConfig.featured.block1.altText" />
          <Title class="w-4/5" :text="$t(brandConfig.featured.block1.title)">
            {{ $t(brandConfig.featured.block1.description) }}
          </Title>
          <!-- <Tag>{{ $t(getConfig.featured.block1.tag) }}</Tag> -->
          <Link
            class="hidden lg:block"
            :to="brandConfig.featured.block1.events_link"
            :label="$t(brandConfig.featured.block1.linktext)" />
          <Link
            class="block text-sm lg:hidden"
            :to="brandConfig.featured.block1.events_link"
            :label="$t(brandConfig.featured.block1.linktextmobile)" />
        </Card>
        <div class="flex justify-between" :class="getLocale() === 'ar' ? '' : 'space-x-4'">
          <Card :to="brandConfig.featured.block2.to" :class="getLocale() === 'ar' ? 'ml-4' : ''">
            <CoverPhoto
              :use-full-path="isStrapiConf"
              :src="brandConfig.featured.block2.photo"
              :alt="brandConfig.featured.block2.altText" />
            <Title class="w-1/2" :text="$t(brandConfig.featured.block2.title)" />
            <!-- <Tag>{{ $t(getConfig.featured.block2.tag) }}</Tag> -->
            <Link
              class="hidden xl:block"
              :to="brandConfig.featured.block2.events_link"
              :label="$t(brandConfig.featured.block2.linktext)" />
            <Link
              class="block text-sm xl:hidden"
              :to="brandConfig.featured.block2.events_link"
              :label="$t(brandConfig.featured.block2.linktextmobile)" />
          </Card>
          <Card :to="brandConfig.featured.block3.to">
            <CoverPhoto
              :use-full-path="isStrapiConf"
              :src="brandConfig.featured.block3.photo"
              :alt="brandConfig.featured.block3.altText" />
            <Title class="w-1/2" :text="$t(brandConfig.featured.block3.title)" />
            <!-- <Tag>{{ $t(getConfig.featured.block3.tag) }}</Tag> -->
            <Link
              class="hidden xl:block"
              :to="brandConfig.featured.block3.events_link"
              :label="$t(brandConfig.featured.block3.linktext)" />
            <Link
              class="block text-sm xl:hidden"
              :to="brandConfig.featured.block3.events_link"
              :label="$t(brandConfig.featured.block3.linktextmobile)" />
          </Card>
        </div>
      </div>
      <div class="w-half lg:w-1/2 flex-col gap-6">
        <Card class="mb-4" :to="brandConfig.featured.block4.to">
          <CoverPhoto
            :use-full-path="isStrapiConf"
            :src="brandConfig.featured.block4.photo"
            :alt="brandConfig.featured.block4.altText" />
          <Title class="w-4/5" :text="$t(brandConfig.featured.block4.title)">
            {{ $t(brandConfig.featured.block4.description) }}
          </Title>
          <!-- <Tag>{{ $t(getConfig.featured.block4.tag) }}</Tag> -->
          <Link
            v-if="brandConfig.featured.block4.events_link"
            class="hidden xl:block"
            :to="brandConfig.featured.block4.events_link"
            :label="$t(brandConfig.featured.block4.linktext)" />
          <Link
            v-if="brandConfig.featured.block4.events_link"
            class="block text-sm xl:hidden"
            :to="brandConfig.featured.block4.events_link"
            :label="$t(brandConfig.featured.block4.linktextmobile)" />
        </Card>
        <div class="flex justify-between" :class="getLocale() === 'ar' ? '' : 'space-x-4'">
          <Card :to="brandConfig.featured.block5.to" :class="getLocale() === 'ar' ? 'ml-4' : ''">
            <CoverPhoto
              :use-full-path="isStrapiConf"
              :src="brandConfig.featured.block5.photo"
              :alt="brandConfig.featured.block5.altText" />
            <Title class="w-1/2" :text="$t(brandConfig.featured.block5.title)" />
            <!-- <Tag>{{ $t(getConfig.featured.block5.tag) }}</Tag> -->
            <Link
              v-if="brandConfig.featured.block5.events_link"
              class="hidden xl:block"
              :to="brandConfig.featured.block5.events_link"
              :label="$t(brandConfig.featured.block5.linktext)" />
            <Link
              v-if="brandConfig.featured.block5.events_link"
              class="block text-sm xl:hidden"
              :to="brandConfig.featured.block5.events_link"
              :label="$t(brandConfig.featured.block5.linktextmobile)" />
          </Card>
          <Card :to="brandConfig.featured.block6.to">
            <CoverPhoto
              :use-full-path="isStrapiConf"
              :src="brandConfig.featured.block6.photo"
              :alt="brandConfig.featured.block6.altText" />
            <Title class="w-1/2" :text="$t(brandConfig.featured.block6.title)" />
            <!-- <Tag>{{ $t(getConfig.featured.block6.tag) }}</Tag> -->
            <Link
              v-if="brandConfig.featured.block6.events_link"
              class="hidden xl:block"
              :to="brandConfig.featured.block6.events_link"
              :label="$t(brandConfig.featured.block6.linktext)" />
            <Link
              v-if="brandConfig.featured.block6.events_link"
              class="block text-sm xl:hidden"
              :to="brandConfig.featured.block6.events_link"
              :label="$t(brandConfig.featured.block6.linktextmobile)" />
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getLocale } from "@/components/page/menu/locales.js";
import { Card, CoverPhoto, Link, Title } from "@/components/card";
import { brandconfig, shop } from "@/brandconfig";
import { normalizeHomePageBlocks, useGetBrandHomePageSections } from "@/composables/strapi/api/brands";
import { computed } from "vue";

const { data, isLoading } = useGetBrandHomePageSections(shop.key);
const isStrapiConf = computed(() => Boolean(data?.value?.data?.length));

const brandConfig = computed(() => {
  if (!data?.value || !data.value?.data.length) {
    return brandconfig;
  }

  const normalizedData = normalizeHomePageBlocks(data.value);

  return Object.keys(normalizedData?.featured?.block1).length ? normalizedData : brandconfig;
});
</script>
